import { render } from "./permission-index.vue?vue&type=template&id=88aff91a"
import script from "./permission-index.vue?vue&type=script&lang=js"
export * from "./permission-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__